<template>
  <b-row class="match-height">
    <b-col cols="12">
      <b-card :title="this.$route.meta.title">
        <b-alert
          v-height-fade
          dismissible
          v-model="showDismissibleAlert"
          fade
          class="mb-2"
          variant="danger"
          v-id="showDismissibleAlert == true"
        >
          <div class="alert-body">
            <span>{{ messages }}</span>
          </div>
        </b-alert>
        <ValidationObserver v-slot="{ handleSubmit }">
          <b-form @submit.prevent="handleSubmit(save)">
            <b-row>
              <b-col md="4">
                <ValidationProvider
                  name="Nama (ID)"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-form-group label="Nama (ID)" label-for="mc-name">
                    <b-form-input
                      id="mc-name"
                      placeholder="Masukkan Nama (ID)"
                      v-model="model.name"
                    />

                    <p class="fs-6 text-danger">
                      {{ errors[0] }}
                    </p>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="4">
                <ValidationProvider
                  name="Nama (EN)"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-form-group label="Nama (EN)" label-for="mc-name">
                    <b-form-input
                      id="mc-name"
                      placeholder="Masukkan Nama (EN)"
                      v-model="model.name_en"
                    />

                    <p class="fs-6 text-danger">
                      {{ errors[0] }}
                    </p>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col md="4">
                <ValidationProvider
                  name="Category"
                  v-slot="{ errors }"
                >
                  <b-form-group label="Category" label-for="mc-category">
                    <select
                      class="form-control"
                      v-model="model.parent_id"
                    >
                      <option :value="0">Top Level (No Parent)</option>
                      <option
                        v-for="(i, index) in categories"
                        :key="index"
                        :value="i.id"
                      >
                        {{ i.name }}
                      </option>
                    </select>

                    <p class="fs-6 text-danger">
                      {{ errors[0] }}
                    </p>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col md="4">
                <ValidationProvider
                  name="Status"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-form-group label="Status" label-for="mc-status">
                    <b-form-radio-group
                      v-model="model.status"
                      :options="statusList"
                      class="mt-1"
                      value-field="value"
                      text-field="label"
                    />
                    <p class="fs-6 text-danger">
                      {{ errors[0] }}
                    </p>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
            </b-row>
            <b-card-footer>
              <!-- submit and reset -->
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1 float-right"
              >
                Simpan
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                class="mr-1 float-right"
                variant="outline-secondary"
                :to="{ name: 'category_indicators' }"
              >
                Batal
              </b-button>
            </b-card-footer>
          </b-form>
        </ValidationObserver>
      </b-card>
    </b-col>
  </b-row>
</template>

<style>
.mx-datepicker {
  width: 100% !important;
}
</style>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormFile,
  BFormCheckbox,
  BForm,
  BButton,
  BCard,
  BCardFooter,
  BFormRadioGroup,
  BFormInvalidFeedback,
  BFormValidFeedback,
  BFormTextarea,
  BAlert,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import axios from "@axios";
import { heightFade } from "@core/directives/animations";

export default {
  components: {
    BCard,
    BCardFooter,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormCheckbox,
    BForm,
    BButton,
    BFormRadioGroup,
    vSelect,
    BFormInvalidFeedback,
    BFormValidFeedback,
    BFormTextarea,
    BAlert,
  },
  directives: {
    Ripple,
    "height-fade": heightFade,
  },
  data() {
    return {
      name: "UsersForm",
      errors: {},
      showDismissibleAlert: false,
      config: {
        api: "/category_indicator",
        redirect: "category_indicators",
        category: "/category_indicator?orderby=id&sort=desc&parent_id=0",
      },
      model: {
        parent_id: 0,
        status: "active",
      },
      confirmPass: null,
      roles: [
        // {
        //   id: 1,
        //   name: "Super Admin",
        // },
      ],
      statusList: [
        {
          label: "Aktif",
          value: "active",
        },
        {
          label: "Tidak Aktif",
          value: "inactive",
        },
      ],
      messages: "",
      categories: [],
    };
  },
  mounted() {
    let _ = this;
    _.getData();
    _.getCategories();
  },
  methods: {
    getCategories() {
      let _ = this;
      if (this.$route.meta.action == "edit") {
        axios.get(_.config.category).then((response) => {
          _.categories = response.data.data.rows;
          const filtered = _.categories.filter((item) => {
              return item.id != this.$route.params.id;
          });
          _.categories = filtered
        });
      }else{
        axios.get(_.config.category).then((response) => {
          _.categories = response.data.data.rows;
        });
      }
      
    },
    getData() {
      let _ = this;
      if (this.$route.meta.action == "edit") {
        axios
          .get(_.config.api + "/" + this.$route.params.id)
          .then((response) => {
            let _ = this;
            _.model = response.data.data;
          });
      }
    },
    save() {
      let _ = this;
      if (this.$route.meta.action == "store") {
        axios
          .post(_.config.api, _.model)
          .then((res) => {
            _.$router.push({
              name: _.config.redirect,
              params: {
                event: "success",
                title: "Create Success",
                text: res.data.message,
              },
            });
          })
          .catch((e) => {
            // console.log(e.response.data.message.errors[0].msg);
            let vm = this;
            vm.showDismissibleAlert = true;
            if (typeof e.response.data.message === "object") {
              vm.messages = e.response.data.message.errors[0].msg;
            } else {
              vm.messages = e.response.data.message;
            }
          });
      } else {
        _.model.id = _.$route.params.id;
        let data = {
          name: _.model.name,
          status: _.model.status,
          name_en: _.model.name_en,
          parent_id: _.model.parent_id,
        };
        axios
          .put(_.config.api + "/" + _.$route.params.id, data)
          .then((res) => {
            _.$router.push({
              name: _.config.redirect,
              params: {
                event: "success",
                title: "Update Category Success",
                text: res.data.message,
              },
            });
          })
          .catch((e) => {
            let vm = this;
            vm.showDismissibleAlert = true;
            if (typeof e.response.data.message === "object") {
              vm.messages = e.response.data.message.errors[0].msg;
            } else {
              vm.messages = e.response.data.message;
            }
          });
      }
    },
  },
};
</script>
